import { FilterFieldType, IFilter } from './types'

export const FINANCIALS_COMPARISON_LIST_FILTERS_CONFIG = [
  {
    field: 'clientName',
    dbField: 'client_name',
    type: FilterFieldType.Text,
    title: 'Client Name',
    isSortable: true,
    alias: 'ci',
  },
  {
    field: 'industry',
    type: FilterFieldType.List,
    title: 'Industry',
    isSortable: true,
    alias: 'ci',
    isMultiple: true,
  },
  {
    field: 'riskRating',
    type: FilterFieldType.Number,
    dbField: 'risk_rating',
    title: 'Risk Rating',
    isSortable: true,
    alias: 'rr',
  },
  {
    field: 'metric1',
    type: FilterFieldType.Number,
    title: 'Actual',
    isSortable: true,
    aggColumn: true,
  },
  {
    field: 'metric1PercentRevenue',
    type: FilterFieldType.Percent,
    title: 'Act. % Rev',
    isSortable: true,
    aggColumn: true,
  },
  {
    field: 'metric1Projection',
    type: FilterFieldType.Number,
    title: 'Projections',
    isSortable: true,
    aggColumn: true,
  },
  {
    field: 'metric1ProjectionPercentRevenue',
    type: FilterFieldType.Percent,
    title: 'Proj % Rev',
    isSortable: true,
    aggColumn: true,
  },
  {
    field: 'metric1DifferencePercentage',
    type: FilterFieldType.Percent,
    title: '% Difference',
    isSortable: true,
    aggColumn: true,
  },
  {
    field: 'metric2',
    type: FilterFieldType.Number,
    title: 'Actual',
    isSortable: true,
    aggColumn: true,
  },
  {
    field: 'metric2PercentRevenue',
    type: FilterFieldType.Percent,
    title: 'Act. % Rev',
    isSortable: true,
    aggColumn: true,
  },
  {
    field: 'metric2Projection',
    type: FilterFieldType.Number,
    title: 'Projections',
    isSortable: true,
    aggColumn: true,
  },
  {
    field: 'metric2ProjectionPercentRevenue',
    type: FilterFieldType.Percent,
    title: 'Proj % Rev',
    isSortable: true,
    aggColumn: true,
  },
  {
    field: 'metric2DifferencePercentage',
    type: FilterFieldType.Percent,
    title: '% Difference',
    isSortable: true,
    aggColumn: true,
  },
] as const satisfies IFilter[]
